import request from '@/api/request'

/**
 * Fetch current SSO principal (authenticated user info).
 * Backend: GET /insights/sso/v2/principal
 *
 * The default baseURL is `/insights`, so we just use the relative path here.
 * CloudFront's `/insights/*` cache behavior already forwards this to the
 * backend ECS origin.
 */
export function getPrincipal() {
  return request({
    url: '/sso/v2/principal',
    method: 'get',
  })
}

/**
 * Logout the current SSO session.
 *
 * Spring Security's default logout endpoint is POST /logout on the backend
 * — it is NOT under /insights/*, so we must override the default `/insights`
 * baseURL with an empty string. CloudFront has a dedicated `/logout` cache
 * behavior that proxies this to the backend ECS origin.
 *
 * This mirrors cfes-admin-frontend-vue3's logout() implementation so that
 * both admin SPAs share the same battle-tested approach.
 */
export function logout() {
  return request({
    baseURL: '',
    url: '/logout',
    method: 'post',
  })
}
